<template>
  <!-- TODO: make a dumb component -->
  <footer class="mpf-footer" role="contentinfo">
    <div class="mpf-width-container">
      <div class="mpf-grid-row">
        <div class="mpf-u-margin-bottom-3 mpf-grid-column-one-half">
          <p class="mpf-body-s mpf-u-margin-bottom-1">Powered by</p>
          <span class="brand-logo brand-logo-medicus" aria-hidden="true"></span>
        </div>
        <div class="mpf-footer__meta mpf-grid-column-one-half">
          <p class="mpf-body-s mpf-u-margin-top-5 mpf-u-text-align-right">
            {{ tenantStore.tenant?.localOrganisation?.name }}
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>
<script setup lang="ts">
  import { useTenantStore } from '../../stores/useTenantStore';
  const tenantStore = useTenantStore();
</script>
